// extracted by mini-css-extract-plugin
export default {"circlePlaySolid":"PuntosAcumulados_circlePlaySolid__LTSYH","icon12":"PuntosAcumulados_icon12__L5k+E"};